import React from 'react'
import { useHistory } from 'react-router-dom'
import { UseQueryResult } from 'react-query'
import FhirLoader from '../../../../FhirLoader'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import { Observation } from '@teschglobal/tg-fhir-react-components'
import useFhirResourceById from '../../../../../hooks/admin/useFhirResourceById'
import type { Observation as FHIRObservation } from '@teschglobal/tg-fhir-react-components/dist/types'

type ObservationDetailProps = {
  detailId: string | undefined
}

const ObservationDetail: React.FC<ObservationDetailProps> = ({ detailId }) => {
  const history = useHistory()

  const {
    patientAccessFhirConfig,
    handleSelectPractitioner
  } = useFhirConfig()

  const {
    data: observation,
    isFetching,
    isLoading,
    isError
  }: UseQueryResult<FHIRObservation, Error> =
    useFhirResourceById('Patient Access', detailId || '', 'Observation')

  if (isFetching || isLoading) {
    return <FhirLoader />
  }

  if (!observation || isError) {
    return <div className='text-center' role='status' aria-live='polite' aria-atomic='true'>Not Found</div>
  }

  return (
    <div>
      <section>
        <Observation
          data={observation}
          fhirApiConfig={patientAccessFhirConfig}
          onSelectPractitioner={handleSelectPractitioner}
        />
      </section>
    </div>
  )
}

export default ObservationDetail